import React, { useState, useEffect, createRef } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { validDOB, validName, validNumbers, encyptor, decrptor } from "./regex";
import { _axios } from "../../plugins/axios";
import { URL, retailCorporate } from "../../constants/constant";

const DependantEditCustomer = (props) => {
  const [gender, setGender] = useState(props.dataparenttochild.patientDetails[0].patientGender);
  const [adhar, setAdhar] = useState(decrptor(props.dataparenttochild.patientDetails[0].aadharNumber));
  const [dob, setDOB] = useState(props.dataparenttochild.patientDetails[0].patientDOB);
  const [name, setName] = useState(props.dataparenttochild.patientDetails[0].name);
  const [passPort, setPassPort] = useState(decrptor(props.dataparenttochild.patientDetails[0].passPort));

  const patientName = createRef(null);
  const patientAge = createRef(null);
  const patientGender = createRef(null);
  const patientAdharNum = createRef(null);
  const patientPassportNum = createRef(null);

  const [crtAdhaar, setCrtAdhaar] = useState(false);
  const [CrtName, setCrtName] = useState(false);
  const [CrtAge, setCrtAge] = useState(false);
  const [crtAoP, setCrtAoP] = useState(false);
  const corporateId = props.dataparenttochild.patientDetails[0].corporateId;
  const fetchResult = (e, result) => {
    e.preventDefault();
    const obj = {
      access_token: "trialTest",
      updateUserPrameters: true,
      currentStatusId: props.dataparenttochild.orderStatus.currentStatusId,
      dependantId: props.dataparenttochild.dependantId,
      executeAtPatientLevel: true,
      patientDetails: {
        name: result[0],
        dob: result[1],
        gender: result[3],
        aadharNumber: encyptor(result[2]),
        passPort: encyptor(result[4]),
      },
    };

    const url = `${URL.dev_url}updateorders`;

    _axios
      .post(url, obj)
      .then(async function (res) {
        if (res.data) {
          props.parentCallback(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
        props.parentCallback(err);
      });

    props.onHide();
  };

  window.addEventListener("setPatientUpdateEvent", (ev) => {
    console.log("event triggered", ev.detail);
    let obj = [patientName.current.value, patientAge.current.value, patientAdharNum.current.value];
    obj = ev.detail;
    ev.stopImmediatePropagation();
  });

  const handleGenderChange = (event) => {
    setGender(event.target.value);
    console.log(patientGender.current.value);
  };

  const handleDOBChange = (event) => {
    if ([4, 7].includes(patientAge.current.value.length) && event.nativeEvent.inputType != "deleteContentBackward") {
      patientAge.current.value = patientAge.current.value.concat("-");
    }

    if (patientAge.current.value.length === 10 && validDOB.test(patientAge.current.value) && ![null, "", " "].includes(patientAge.current.value)) {
      setCrtAge(true);
    } else {
      setCrtAge(false);
    }
    setDOB(patientAge.current.value);
  };

  const handleChangeName = (event) => {
    if (validName.test(patientName.current.value) && ![null, "", " "].includes(patientName.current.value)) {
      setCrtName(true);
    } else {
      setCrtName(false);
    }

    setName(patientName.current.value);
  };

  const handleChangePassport = (event) => {
    setPassPort(patientPassportNum.current.value);
    if (
      props.dataparenttochild.aadharRequired
        ? crtAdhaar
          ? crtAdhaar || ![null, "", " "].includes(patientPassportNum.current.value)
          : false
        : crtAdhaar
    ) {
      setCrtAoP(true);
    } else {
      setCrtAoP(false);
    }

    if (
      props.dataparenttochild.aadharRequired
        ? validNumbers.test(patientAdharNum.current.value) &&
          (patientAdharNum.current.value.length === 14 ||
            (patientAdharNum.current.value.length === 15 && patientAdharNum.current.value.charAt(14) === " ") ||
            ([null, ""].includes(patientAdharNum.current.value) && ![null, "", " "].includes(patientPassportNum.current.value)))
        : [null, ""].includes(patientAdharNum.current.value) ||
          (validNumbers.test(patientAdharNum.current.value) &&
            (patientAdharNum.current.value.length === 14 ||
              (patientAdharNum.current.value.length === 15 && patientAdharNum.current.value.charAt(14) === " ")))
    ) {
      setCrtAdhaar(true);
    } else {
      setCrtAdhaar(false);
    }
  };

  const handleChangeAdhar = (event) => {
    if ((patientAdharNum.current.value.length + 1) % 5 === 0 && event?.nativeEvent?.inputType != "deleteContentBackward") {
      patientAdharNum.current.value = patientAdharNum.current.value.concat(" ");
    }
    setAdhar(patientAdharNum.current.value);

    if (
      props.dataparenttochild.aadharRequired
        ? validNumbers.test(patientAdharNum.current.value) &&
          (patientAdharNum.current.value.length === 14 ||
            (patientAdharNum.current.value.length === 15 && patientAdharNum.current.value.charAt(14) === " ") ||
            ([null, ""].includes(patientAdharNum.current.value) && ![null, "", " "].includes(patientPassportNum.current.value)))
        : [null, ""].includes(patientAdharNum.current.value) ||
          (validNumbers.test(patientAdharNum.current.value) &&
            (patientAdharNum.current.value.length === 14 ||
              (patientAdharNum.current.value.length === 15 && patientAdharNum.current.value.charAt(14) === " ")))
    ) {
      setCrtAdhaar(true);
    } else {
      setCrtAdhaar(false);
    }
  };

  const runthis = () => {
    if (
      props.dataparenttochild.aadharRequired
        ? crtAdhaar
          ? crtAdhaar || ![null, "", " "].includes(patientPassportNum.current.value)
          : false
        : crtAdhaar
    ) {
      setCrtAoP(true);
    } else {
      setCrtAoP(false);
    }
  };

  useEffect(() => {
    handleChangeName();
    handleChangeAdhar();
    handleDOBChange();
    handleChangePassport();
    runthis();
  }, [crtAdhaar]);

  return (
    <div>
      <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Update Patient Details</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ height: "550px", padding: "5px" }}>
          <div className="display-center position-relative">
            <div className="pt-1">
              <Form
                onSubmit={(e) =>
                  fetchResult(e, [
                    patientName.current.value,
                    patientAge.current.value,
                    patientAdharNum.current.value,
                    patientGender.current.value,
                    patientPassportNum.current.value,
                  ])
                }
              >
                <Form.Group className="mb-3" controlId="Name">
                  <Form.Label>Patient Name:</Form.Label>
                  <Form.Control
                    required
                    ref={patientName}
                    type="text"
                    placeholder="Enter patient name"
                    onChange={(e) => handleChangeName(e)}
                    disabled={corporateId != retailCorporate && !props.isPPMC}
                    defaultValue={name}
                    value={name}
                    isInvalid={!CrtName && name != null}
                    isValid={CrtName}
                  />
                  <Form.Control.Feedback type="invalid">Please provide a valid name.</Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="Age">
                  <Form.Label>Date Of Birth (YYYY-MM-DD):</Form.Label>
                  <Form.Control
                    required
                    ref={patientAge}
                    type="Age"
                    placeholder="DOB (YYYY-MM-DD)"
                    defaultValue={dob}
                    isValid={CrtAge}
                    value={dob}
                    disabled={corporateId != retailCorporate && !props.isPPMC}
                    isInvalid={!CrtAge && dob != null}
                    onChange={(e) => handleDOBChange(e)}
                  />
                  <Form.Control.Feedback type="invalid">Please provide a valid Date of birth.</Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Gender: </Form.Label>
                  <Form.Control
                    required
                    ref={patientGender}
                    as="select"
                    size="sm"
                    name="request"
                    value={gender}
                    disabled={corporateId != retailCorporate && !props.isPPMC}
                    onChange={(e) => handleGenderChange(e)}
                  >
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </Form.Control>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Aadhaar Number:</Form.Label>
                  <Form.Control
                    ref={patientAdharNum}
                    controlId="adhaar"
                    type="Age"
                    placeholder="Aadhar Number"
                    defaultValue={adhar}
                    isInvalid={!crtAdhaar}
                    isValid={crtAdhaar && ![null, ""].includes(adhar)}
                    value={adhar}
                    onChange={(e) => handleChangeAdhar(e)}
                  />
                  <Form.Control.Feedback type="invalid">Please provide a valid Aadhar-Number.</Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Passport No / Voter ID:</Form.Label>
                  <Form.Control
                    ref={patientPassportNum}
                    controlId="adhaar"
                    type="Age"
                    placeholder="Passport No / Voter ID"
                    defaultValue={passPort}
                    // isInvalid={!crtAdhaar}
                    // isValid = {crtAdhaar && ![null,"", " "].includes( adhar)}
                    value={passPort}
                    onChange={(e) => handleChangePassport(e)}
                  />
                </Form.Group>

                <Button
                  variant="primary"
                  type="submit"
                  disabled={!crtAoP || !CrtName || !CrtAge || !patientGender}
                  className="text-align-center w-100"
                >
                  {" "}
                  Save{" "}
                </Button>
                <hr />
              </Form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default DependantEditCustomer;
